export const PRICE_DROP_SOURCE = {
    DESKTOP: "DESKTOP",
    MSITE: "MSITE"
};
